'use client';
var themeClasses = {"theme":"m_1f5e827e"};

export { themeClasses as default };
//# sourceMappingURL=CodeHighlight.theme.module.css.mjs.map
